module.exports = __webpack_public_path__ + "img/AP18.3b14af12.jpg";